import {Injectable} from '@angular/core';
import {Configurator, ConfiguratorUtilsService} from '@spartacus/product-configurator/rulebased';

@Injectable({
  providedIn: 'root',
})
export class DcpConfiguratorUtilsService extends ConfiguratorUtilsService {
  constructor() {
    super();
  }

  createConfigurationExtractFromMultipleAttributes(
    changedAttributes: Configurator.Attribute[],
    configuration: Configurator.Configuration,
    updateType?: Configurator.UpdateType,
  ): Configurator.Configuration {
    if (!updateType) {
      updateType = Configurator.UpdateType.ATTRIBUTE;
    }
    const newConfiguration: Configurator.Configuration = {
      configId: configuration.configId,
      groups: [],
      flatGroups: [],
      interactionState: {},
      owner: configuration.owner,
      productCode: configuration.productCode,
      updateType,
      buttonActions: configuration.buttonActions,
    };

    changedAttributes.forEach((changedAttribute) => {
      const groupPath: Configurator.Group[] = [];
      if (changedAttribute.groupId) {
        this.buildGroupPath(changedAttribute.groupId, configuration.groups, groupPath);
      } else {
        throw Error('GroupId must be available at attribute level during update');
      }

      const groupPathLength = groupPath.length;

      if (groupPathLength === 0) {
        throw new Error(
          'At this point we expect that group is available in the configuration: ' +
            changedAttribute.groupId +
            ', ' +
            JSON.stringify(configuration.groups.map((cGroup) => cGroup.id)),
        );
      }

      let currentGroupInExtract: Configurator.Group = this.buildGroupForExtract(groupPath[groupPathLength - 1]);

      let currentLeafGroupInExtract: Configurator.Group = currentGroupInExtract;

      newConfiguration.groups.push(currentGroupInExtract);

      for (let index = groupPath.length - 1; index > 0; index--) {
        currentLeafGroupInExtract = this.buildGroupForExtract(groupPath[index - 1]);
        currentGroupInExtract.subGroups = [currentLeafGroupInExtract];
        currentGroupInExtract = currentLeafGroupInExtract;
      }

      currentLeafGroupInExtract.attributes = [changedAttribute];
    });
    return newConfiguration;
  }
}
